import styled from 'styled-components';

import Eyebrow from '@klv/atoms/eyebrow';
import Typography from '@klv/atoms/typography';
import Grid from '@klv/utils/grid';
import type { ICustomThemeProps } from '@klv/shared/styles/themes/styled';
import type { TMediaAlignment } from '../types';


export const StyledGrid = styled(Grid)`
  align-items: center;
`;

export const StyledEyebrow = styled(Eyebrow)`
  margin-bottom: 1.6rem;
`;

export const StyledHeadline = styled(Typography)`
  margin-bottom: 2.7rem;
`;

export const StyledSubhead = styled(Typography)`
`;

export const GridText = styled.div<{ $fullWidth: boolean; $mediaAlignment: TMediaAlignment; }>`
  grid-column: 1 / -1;
  grid-row: 2;
  ${({ theme, $mediaAlignment }) => `
    ${theme.screenSize.s768.mediaQuery} {
      grid-column: ${$mediaAlignment === 'right' ? '1 / 6' : '8 / -1'};
      grid-row: 1; 
    }
  `}
  ${({ theme, $fullWidth }) => {
    if ($fullWidth) {
      return `
        ${theme.screenSize.s768.mediaQuery} {
          grid-column: 1 / -1;
          grid-row: 1; 
        }
      `;
    }

    return '';
  }}
`;

export const GridMedia = styled.div<{ $mediaAlignment: TMediaAlignment; $mediaOverride: boolean; }>`
  ${({ theme, $mediaAlignment, $mediaOverride }) => `
    display: ${$mediaOverride ? 'block' : 'none'};
    grid-column: 1 / -1;
    grid-row: 12;
    margin-bottom: 3.2rem;
    ${theme.screenSize.s768.mediaQuery} {
      display: block;
      grid-column: ${$mediaAlignment === 'right' ? '7 / -1' : '1 / 7'};
      grid-row: 1;
    }
  `}
`;

export const StyledAccordion = styled.div<{ $variant: string; $academyVariant?: boolean; }>`
  ${({ theme, $variant, $academyVariant }) => `
    background-color: ${theme.accordion[$variant as keyof ICustomThemeProps['accordion']].background};
 
    ${$academyVariant ? 'margin:0 0 8rem 0;' : theme.globalPadding}
  
    ${StyledEyebrow}, ${StyledHeadline}, ${StyledSubhead}, ${GridText} {
      color: ${theme.accordion[$variant as keyof ICustomThemeProps['accordion']].text};

    }
  `}
`;
